import "./AccountFlyoutDropdown.scss";

import * as React from "react";
import { BusinessAccountResponse } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { AccountFlyoutGreeting } from "./AccountFlyoutGreeting";
import { AccountFlyoutBlueSection } from "./AccountFlyoutBlueSection";
import { AccountFlyoutBottomLinks } from "./AccountFlyoutBottomLinks";
import { AccountFlyoutMenuSection } from "./AccountFlyoutMenuSection";
import { AccountFlyoutAccountSwitch } from "./AccountFlyoutAccountSwitch";
import { AccountFlyoutAccountSwitchPage } from "./AccountFlyoutAccountSwitchPage";
import { AccountFlyoutSubMenuPage } from "./AccountFlyoutSubMenuPage";

type Props = {
    businessAccount: BusinessAccountResponse;
    tierLevel: string | undefined;
    display: boolean;
    setIsMenuVisible: (isMenuVisible: boolean) => void;
};

type State = {
    accountDropdownPage: number;
};

class AccountFlyoutDropdown extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { accountDropdownPage: 1 };
    }

    setAccountFlyoutPage(pageNumber: number) {
        this.setState({ accountDropdownPage: pageNumber });
    }

    renderAcountSwitch() {
        return (
            <React.Fragment>
                {this.props.businessAccount && (
                    <AccountFlyoutAccountSwitchPage
                        businessAccountsResponse={this.props.businessAccount}
                        setPageNumber={this.setAccountFlyoutPage.bind(this)}
                        display={this.props.display && this.state.accountDropdownPage === 2}
                    />
                )}
            </React.Fragment>
        );
    }

    renderSubMenuItems() {
        return (
            <React.Fragment>
                {this.props.businessAccount && (
                    <AccountFlyoutSubMenuPage
                        setPageNumber={this.setAccountFlyoutPage.bind(this)}
                        display={this.props.display && this.state.accountDropdownPage === 3}
                    />
                )}
            </React.Fragment>
        );
    }
    render() {
        const accountFlyoutClassName = this.props.display ? "account-flyout open" : "account-flyout";

        return (
            <div className={accountFlyoutClassName}>
                <div className="overlay-flyout" />
                <div className="white-section">
                    <AccountFlyoutGreeting
                        setIsMenuVisible={this.props.setIsMenuVisible}
                        person={this.props.businessAccount.person}
                    />
                    <AccountFlyoutBlueSection
                        businessAccount={this.props.businessAccount.getActiveAccount()}
                        activeAccountId={this.props.businessAccount.activeAccountId}
                    />
                    <AccountFlyoutAccountSwitch
                        setPageNumber={this.setAccountFlyoutPage.bind(this)}
                        businessAccount={this.props.businessAccount}
                    />
                    <AccountFlyoutMenuSection
                        businessAccount={this.props.businessAccount.getActiveAccount()}
                        activeAccountId={this.props.businessAccount.activeAccountId}
                        setPageNumber={this.setAccountFlyoutPage.bind(this)}
                        person={this.props.businessAccount.person}
                    />
                    <AccountFlyoutBottomLinks
                        activeAccountId={this.props.businessAccount.activeAccountId}
                        tierLevel={this.props.tierLevel}
                    />
                </div>
                {this.renderAcountSwitch()}
                {this.renderSubMenuItems()}
            </div>
        );
    }
}

export default AccountFlyoutDropdown;
